import styled from 'styled-components';

const OnlineListWrap = styled.div`
    color: #666666;
    margin-top: 1.25rem;
`;

export default OnlineListWrap;